import { useEffect } from "react";
import { isLessonIncompleteAI } from "@src/features/contentDetail/utils/courses";
import { cloneDeep } from "lodash";
import {
  CourseContentCourseVersionFragment,
  CourseContentLessonFragment,
} from "../build/CourseBuildContent.generated";
import { getCourseBuilderState } from "../stores/useCourseBuilderStore";

type Args = {
  initialOrPollingCourseVersion:
    | CourseContentCourseVersionFragment
    | undefined
    | null;
};

const useUpdateAILessons = ({ initialOrPollingCourseVersion }: Args): void => {
  useEffect(() => {
    const store = getCourseBuilderState();
    const courseVersion = store.courseVersion;
    if (!courseVersion || !initialOrPollingCourseVersion) return;
    if (!courseVersion.lessons.some((lesson) => isLessonIncompleteAI(lesson))) {
      return;
    }
    const lessons = courseVersion.lessons.map<CourseContentLessonFragment>(
      (lesson) => {
        if (isLessonIncompleteAI(lesson)) {
          const newLesson = initialOrPollingCourseVersion.lessons.find(
            (l) => l.uuid === lesson.uuid,
          );
          return newLesson ? newLesson : lesson;
        }
        return lesson;
      },
    );
    store.setCourseVersion({
      ...courseVersion,
      lessons: cloneDeep(lessons),
    });
  }, [initialOrPollingCourseVersion]);
};

export default useUpdateAILessons;
